"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProjectViewType = exports.PipelineBuilderNodeType = exports.projectRunFilterMap = exports.projectPipelineEncodedFields = exports.projectRunSortMap = exports.projectUpdateSetFieldMap = exports.projectFilterMap = exports.projectSortMap = exports.projectEncodedFields = void 0;
exports.projectEncodedFields = [
    "name",
    "summary",
];
exports.projectSortMap = {
    id: "id",
    name: "name",
    summary: "summary",
    owner: "owner",
    vmetaId: "vmetaId",
    own: "own",
    createdAt: "created_at",
    updatedAt: "updated_at",
};
exports.projectFilterMap = {
    id: "p.id",
    name: "p.name",
    owner: "u.username",
    createdAt: "p.date_created",
    updatedAt: "p.date_modified",
};
exports.projectUpdateSetFieldMap = {
    name: "name",
    summary: "summary",
    vmetaId: "vmeta_id",
    groupId: "group_id",
    permission: "perms",
};
exports.projectRunSortMap = {
    total: "total",
    id: "id",
    name: "name",
    description: "description",
    status: "status",
    owner: "owner",
    own: "own",
    pipelineId: "pipeline_id",
    pipelineName: "pipeline_name",
    type: "type",
    createdAt: "created_at",
    updatedAt: "modified_at",
    pipelineVersion: "pipeline_version",
};
exports.projectPipelineEncodedFields = ["name", "description"];
exports.projectRunFilterMap = {
    id: "pro_pip.id",
    name: "pro_pip.name",
    description: "pro_pip.summary",
    status: "r.run_status",
    owner: "pro_pip.owner_id",
    pipelineId: "pip.id",
    pipelineName: "pip.name",
    type: "pro_pip.type",
    createdAt: "pro_pip.date_created",
    updatedAt: "r.date_created_last_run",
};
var PipelineBuilderNodeType;
(function (PipelineBuilderNodeType) {
    PipelineBuilderNodeType["Module"] = "moduleNode";
    PipelineBuilderNodeType["Process"] = "processNode";
    PipelineBuilderNodeType["Category"] = "category";
    PipelineBuilderNodeType["AIModel"] = "modelNode";
    PipelineBuilderNodeType["ModelSkill"] = "skillNode";
})(PipelineBuilderNodeType || (exports.PipelineBuilderNodeType = PipelineBuilderNodeType = {}));
var ProjectViewType;
(function (ProjectViewType) {
    ProjectViewType[ProjectViewType["MyProjects"] = 1] = "MyProjects";
    ProjectViewType[ProjectViewType["SharedWithMe"] = 2] = "SharedWithMe";
    ProjectViewType[ProjectViewType["AdminView"] = 3] = "AdminView";
    ProjectViewType[ProjectViewType["UserOwnedAndGroupShared"] = 4] = "UserOwnedAndGroupShared";
})(ProjectViewType || (exports.ProjectViewType = ProjectViewType = {}));
